if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            'select option[selected], fieldset input:checked'
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT'
          ? target.selectedOptions[0]
          : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS
              .optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues:
                  this.selectedOptionValues,
              },
            }
          );
        });

        this._handleSizeCompareClick = (event) => {
          const clickedElement =
            event.target instanceof Element
              ? event.target
              : event.target.parentElement;

          const card = clickedElement?.closest(
            '[data-size-compare] [data-size-match]'
          );

          if (!card) return;

          const sizeValues = {
            piccolo: ['32x24'],
            medio: ['44x32'],
            grande: ['60x40'],
          };

          const targetDimensions =
            sizeValues[card.dataset.sizeMatch];

          if (!targetDimensions) return;

          const normalize = (value) =>
            (value || '')
              .toString()
              .trim()
              .toLowerCase()
              .replace(/×/g, 'x')
              .replace(/\s+/g, '');

          const matchesSize = (value) => {
            const normalizedValue = normalize(value);

            return targetDimensions.some((dimension) =>
              normalizedValue.includes(normalize(dimension))
            );
          };

          const select = Array.from(
            this.querySelectorAll('select')
          ).find((element) =>
            Array.from(element.options).some(
              (option) =>
                matchesSize(option.value) ||
                matchesSize(option.textContent)
            )
          );

          if (select) {
            const option = Array.from(select.options).find(
              (item) =>
                matchesSize(item.value) ||
                matchesSize(item.textContent)
            );

            if (option) {
              select.value = option.value;

              select.dispatchEvent(
                new Event('input', {
                  bubbles: true,
                })
              );

              select.dispatchEvent(
                new Event('change', {
                  bubbles: true,
                })
              );
            }

            return;
          }

          const control = Array.from(
            this.querySelectorAll(
              'input[type="radio"], button, [role="radio"]'
            )
          ).find((element) => {
            const label = element.id
              ? Array.from(
                  this.querySelectorAll('label')
                ).find(
                  (item) => item.htmlFor === element.id
                )
              : null;

            return [
              element.value,
              element.dataset.value,
              element.dataset.optionValue,
              element.getAttribute('aria-label'),
              label?.textContent,
              element.textContent,
            ].some(matchesSize);
          });

          if (control) {
            const nestedRadio =
              control.querySelector?.(
                'input[type="radio"]'
              );

            (nestedRadio || control).click();
          }
        };

        document.addEventListener(
          'click',
          this._handleSizeCompareClick
        );
      }

      disconnectedCallback() {
        if (this._handleSizeCompareClick) {
          document.removeEventListener(
            'click',
            this._handleSizeCompareClick
          );
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (
          tagName === 'SELECT' &&
          target.selectedOptions.length
        ) {
          const previouslySelected = Array.from(
            target.options
          ).find(
            (option) =>
              option.getAttribute('selected') !== null
          );

          if (previouslySelected) {
            previouslySelected.removeAttribute(
              'selected'
            );
          }

          target.selectedOptions[0].setAttribute(
            'selected',
            'selected'
          );

          const swatchValue =
            target.selectedOptions[0].dataset
              .optionSwatchValue;

          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector(
              '[data-selected-value] > .swatch'
            );

          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              swatchValue
            );

            selectedDropdownSwatchValue.classList.remove(
              'swatch--unavailable'
            );
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch--background',
              'unset'
            );

            selectedDropdownSwatchValue.classList.add(
              'swatch--unavailable'
            );
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset
              .optionSwatchFocalPoint || 'unset'
          );
        } else if (
          tagName === 'INPUT' &&
          target.type === 'radio'
        ) {
          const selectedSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value]');

          if (selectedSwatchValue) {
            selectedSwatchValue.innerHTML = value;
          }
        }
      }
    }
  );
}
